var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonFloodedba7C4986(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80078 30.625C2.80078 30.625 4.50928 32.125 7.92553 32.125C11.3425 32.125 13.051 30.625 13.051 30.625C13.051 30.625 14.7588 32.125 18.1758 32.125C21.5928 32.125 23.3005 30.625 23.3005 30.625C23.3005 30.625 25.009 32.125 28.426 32.125C31.8423 32.125 33.5508 30.625 33.5508 30.625",
    stroke: "#4DBB3E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3359 11.25H29.0504",
    stroke: "#0F0F10",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30078 11.25H9.01528",
    stroke: "#0F0F10",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0508 24.7505H7.30078V15.7505C7.30078 14.9217 7.97203 14.2505 8.80078 14.2505H27.5508C28.3795 14.2505 29.0508 14.9217 29.0508 15.7505V24.7505Z",
    stroke: "#0F0F10",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9258 19.874C25.7542 19.874 26.4258 19.2025 26.4258 18.374C26.4258 17.5456 25.7542 16.874 24.9258 16.874C24.0974 16.874 23.4258 17.5456 23.4258 18.374C23.4258 19.2025 24.0974 19.874 24.9258 19.874Z",
    fill: "#0F0F10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4258 19.874C12.2542 19.874 12.9258 19.2025 12.9258 18.374C12.9258 17.5456 12.2542 16.874 11.4258 16.874C10.5974 16.874 9.92578 17.5456 9.92578 18.374C9.92578 19.2025 10.5974 19.874 11.4258 19.874Z",
    fill: "#0F0F10"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5508 21H20.8008",
    stroke: "#0F0F10",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6758 24.7495V26.2495C10.6758 26.872 10.1733 27.3745 9.55078 27.3745H7.30078C6.67828 27.3745 6.17578 26.872 6.17578 26.2495V24.7495H10.6758Z",
    fill: "#0F0F10"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1758 24.7495V26.2495C30.1758 26.872 29.6733 27.3745 29.0508 27.3745H26.8008C26.1783 27.3745 25.6758 26.872 25.6758 26.2495V24.7495H30.1758Z",
    fill: "#0F0F10"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.578 13.7687L26.1485 8.52773C25.742 7.03598 24.3868 6.00098 22.841 6.00098H13.5065C11.9608 6.00098 10.6055 7.03598 10.199 8.52773L8.76953 13.7687",
    stroke: "#0F0F10",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonFloodedba7C4986);
export default __webpack_public_path__ + "static/media/non-flooded.ba7c4986.f4631867173d3fb1d450b685319f9d83.svg";
export { ForwardRef as ReactComponent };